import React, { useState, useEffect, useRef } from 'react';
import { FormGroup, Label } from 'reactstrap';
import { useDebounce } from '../../hooks/useDebounce';
import { searchOrgUsers } from '../../api/ticketApi';

const DEBOUNCE_MS = 300;
const MIN_SEARCH_LEN = 2;

export default function AddWatcherInput({ onAdded }) {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const containerRef = useRef(null);
  const debouncedQuery = useDebounce(query, DEBOUNCE_MS);

  useEffect(() => {
    if (debouncedQuery.length < MIN_SEARCH_LEN) {
      setResults([]);
      setOpen(false);
      return;
    }
    setLoading(true);
    searchOrgUsers(debouncedQuery)
      .then((list) => {
        setResults(Array.isArray(list) ? list : []);
        setOpen(true);
      })
      .catch(() => {
        setResults([]);
        setOpen(false);
      })
      .finally(() => setLoading(false));
  }, [debouncedQuery]);

  const handleSelect = (user) => {
    setOpen(false);
    setQuery('');
    setResults([]);
    onAdded?.(user);
  };

  return (
    <FormGroup className="mb-0 position-relative" innerRef={containerRef}>
      <Label className="col-form-label" for="add-watcher-input">
        Add watcher
      </Label>
      <input
        id="add-watcher-input"
        type="text"
        className="form-control form-control-sm"
        style={{ minWidth: 280 }}
        placeholder="Search users by name or email"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        aria-label="Add watcher"
        aria-expanded={open}
        autoComplete="off"
      />
      {open && (
        <div
          className="list-group position-absolute w-100 shadow-sm"
          style={{ zIndex: 1300, maxHeight: 300, overflow: 'auto' }}
        >
          {loading ? (
            <button type="button" className="list-group-item list-group-item-action disabled">
              Loading...
            </button>
          ) : results.length === 0 ? (
            <button type="button" className="list-group-item list-group-item-action disabled">
              No users found
            </button>
          ) : (
            results.map((u) => (
              <button
                key={u.userId}
                type="button"
                className="list-group-item list-group-item-action"
                onClick={() => handleSelect(u)}
                role="option"
              >
                {u.userName || u.userEmail || u.userId}
              </button>
            ))
          )}
        </div>
      )}
    </FormGroup>
  );
}
